import R from 'ramda'

import {
  CANADA,
  COUNTRY_CURRENCY,
  EUROPE_COUNTRIES,
} from '../constants/country'
import getInitialState from '../utils/getInitialState'

let state = null
function getState(property) {
  if (state === null) {
    state = getInitialState() || {}
  }

  return state[property]
}

function getList(type) {
  const countries = getState('countries') || {}

  return countries[type] || []
}

function getCountries() {
  return getList('all')
}

function getPriorityCountries() {
  return getList('priority')
}

function getCountrySeparator() {
  return { code: '---------------', name: '---------------', disabled: true }
}

function getProvinces() {
  return getState('provinces') || []
}

function getCountryEmptyValue({ name = 'Select your country' } = {}) {
  return { code: '', name }
}

export function stateLabel(country) {
  if (country === CANADA) {
    return 'Province'
  }

  return 'State'
}

function emptyStateLabel(country) {
  return `Select your ${stateLabel(country)}`
}

function getProvinceEmptyValue({ name = 'Select your province' }) {
  return { code: '', name }
}

let countryOptions = null
export function getCountryOptions({ emptyName } = {}) {
  if (countryOptions === null) {
    countryOptions = [
      getCountryEmptyValue({ name: emptyName }),
      ...getPriorityCountries().map(c => ({ ...c, key: `priority-${c.code}` })),
      getCountrySeparator(),
      ...getCountries(),
    ]
  }

  return countryOptions
}

let provinceOptions = null
export function getProvinceOptions({ emptyName } = {}) {
  if (provinceOptions === null) {
    const provinces = getProvinces()

    // Helper to build the final result
    const buildOptions = (list, emptyLabel) => [
      getProvinceEmptyValue({ name: emptyName || emptyLabel }),
      ...list,
    ]

    // It's an array? Build an array
    if (Array.isArray(provinces)) {
      provinceOptions = buildOptions(provinces)
    } else {
      // It's an object? Build an object indexed by country code
      provinceOptions = R.mapObjIndexed(
        (value, country) => buildOptions(value, emptyStateLabel(country)),
        provinces
      )
    }
  }

  return provinceOptions
}

export function getCountryCurrency(country) {
  if (EUROPE_COUNTRIES.includes(country)) {
    return 'EUR'
  }

  return COUNTRY_CURRENCY[country] || 'USD'
}

export function getBrowserCountry({ fallback = 'US' } = {}) {
  if (
    typeof Intl !== 'object' ||
    typeof Intl.DateTimeFormat !== 'function' ||
    window.timezonesCountry == null
  ) {
    return fallback
  }

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return window.timezonesCountry[timezone] || fallback
}
